import amex from '../images/amex.png';
import diners from '../images/dinners.svg';
import elo from '../images/elo.svg';
import hipercard from '../images/hipercard.png';
import hiper from '../images/hiper.png';
import mastercard from '../images/mastercard.svg';
import visa from '../images/visa.svg';
import channels from '../constants/channels';

const getCardFlagImage = flag =>
  ({
    amex,
    diners,
    elo,
    hipercard,
    hiper,
    mastercard,
    visa,
  }[flag]);

const getCardFlag = (flags, cardNumber) => {
  // TODO: Review this implementation
  let result;
  let flag;
  let subCardNumber;

  const _filteredCardFlag = data => {
    data = data.replace('%', '');
    subCardNumber = cardNumber
      .replace('_', '')
      .substring(0, data.length)
      .replace(/[^0-9]+/g, '');

    if (subCardNumber.includes(data)) {
      result = flag;
    }

    return result;
  };

  for (flag in flags) {
    flags[flag].filter(_filteredCardFlag);
  }

  return result ? result.toString().toLowerCase() : 'default';
};

const currencyFormat = value => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
};

const msisdnFilter = msisdn => msisdn.slice(2).replace(/(\d{2})(\d{4,5})(\d{4})/, '($1) $2-$3');

const cpfFilter = cpf => cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');

const monthFilter = mes_validade => mes_validade.toString().length === 1 ? '0' + mes_validade : mes_validade;

const yearFilter = ano_validade => ano_validade.toString().substring(2);

const isDealersChannel = channel => (channel ? channel.includes('dealers-digitais') : false);

const isClientActive = clientType => (clientType ? clientType.includes('contratoAtivo') : false);

const validateDate = date => {
  let result = { validated: true, message: '' };

  if (date.length > 0 && date.length < 3) {
    result.validated = false;
    result.message = 'Data inválida.';
  } else {
    let month = date.substring(0, 2);
    let year = date.substring(2);
    let currentYear = new Date()
      .getFullYear()
      .toString()
      .substring(2);

    if (month === 0 || month > 12 || year < parseInt(currentYear)) {
      result.validated = false;
      result.message = 'Data inválida.';
    }
  }

  return result;
};

const channelHasBaseUnica = (channel) => {
  return [channels.incentivoRecarga, channels.incentivoFluxoRecargas, channels.callcenterInbound, channels.whatsappEnd2End, channels.whatsappHandover, channels.chatbotAura, channels.portalVivo, channels.captivePreBemobi, channels.chatMovel,
  channels.clmEmail, channels.clmSms, channels.crossAec, channels.crossAtento, channels.emailPedidoCancelado, channels.outActionline, channels.outAec, channels.outAtento, channels.outAtn, channels.outComunicar, channels.outParla,
  channels.outTel, channels.outTelecell, channels.outTmkt, channels.outUranet, channels.outVgx, channels.segmentosSms, channels.incentivoBemobi, channels.carrinhoAbandonadoWebauto, channels.carrinhoAbandonadoLoop,
  channels.captivePreBemobiNc, channels.callCenterOutbound, channels.meuAppVivo, channels.captivePreBemobiNd, channels.octbRcs, channels.octbRcsNovoCartao, channels.octbRcsFallback, channels.appVivo, channels.carrinhoAbandonadoVivoBr, channels.ncPreVivoBr,
  channels.recargaAppUpsellVivoBr, channels.recargaWebUpsellVivoBr, channels.appFbVivoBr, channels.transfligacaoVivoBr, channels.varejoCommcenter, channels.incentivoSatPush, channels.segmentosControlenLojaonline, channels.smsPre2cont].includes(channel);
}

export {
  getCardFlagImage,
  getCardFlag,
  currencyFormat,
  msisdnFilter,
  cpfFilter,
  monthFilter,
  yearFilter,
  isDealersChannel,
  isClientActive,
  validateDate,
  channelHasBaseUnica,
};
